import { CardElement } from "@stripe/react-stripe-js";
import cn from "classnames";
import React from "react";
import { useToggle } from "react-use";

const CardField = ({
  disabled = false,
  className,
  error,
}: {
  disabled?: boolean;
  error?: boolean;
  className?: string;
}) => {
  const [focus, toggle] = useToggle(false);
  return (
    <div
      className={cn(
        "border border-solid border-gray-300 text-base",
        "px-3 py-2.5 rounded shadow-none w-full",
        "outline-none focus:outline-none focus:ring ring-primary ring-opacity-40",
        !disabled && focus && "ring border-primary hover:ring transition-all",
        !disabled && "hover:border-primary hover:ring transition-all",
        error ? "border-red-500" : "",
        className
      )}
    >
      <CardElement
        onFocus={() => {
          toggle(true);
        }}
        onBlur={() => {
          toggle(false);
        }}
        options={{
          hidePostalCode: true,
          disabled,
          style: {
            base: {
              fontFamily: "Inter",
              fontSize: "16px",
              color: "#333333",
              "::placeholder": {
                color: "#DADADA",
              },
              fontSmoothing: "antialiased",
            },
            invalid: {
              color: "#FF4040",
            },
          },
        }}
      />
    </div>
  );
};

export default CardField;
